import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ roles, children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-soft">
        <Loader2 className="w-5 h-5 animate-spin text-navy/60" />
      </div>
    );
  }

  if (!user) {
    const target = roles && roles.includes("client") ? "/login" : "/team/login";
    return <Navigate to={target} replace state={{ from: location.pathname }} />;
  }

  if (roles && !roles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  return children;
}
